import {ExperimentsBag} from '@wix/wix-experiments';

type ExperimentsApi = {
  conduct?: (experimentKey: string, fallbackValue: string) => Promise<string>;
  enabled?: (experimentKey: string) => boolean;
  get?: (experimentKey: string) => string | boolean | undefined;
  ready?: () => Promise<void>;
};
export type ExperimentsInput = ExperimentsBag | ExperimentsApi;

const isEnabledValue = (value: unknown): boolean => value === true || value === 'true';

export const isExperimentEnabled = (experiments: ExperimentsInput = {}, experimentKey: string): boolean => {
  if (typeof experiments.enabled === 'function' && experiments.enabled(experimentKey)) {
    return true;
  }

  if (typeof experiments.get === 'function') {
    return isEnabledValue(experiments.get(experimentKey));
  }

  return isEnabledValue((experiments as ExperimentsBag)[experimentKey]);
};
